export default __webpack_public_path__ + "static/media/simgecan8.af02ba1c.jpg";